import NgoDashboardContainer from "components/ngo-dashbord";
import { useUser } from "hooks";
import { useState } from "react";
import filterImg from "assets/images/filter.svg";
import angle_down from "assets/images/arrowdown.svg";
import calendar from "assets/icons/Icon.svg";
import angle_up from "assets/images/arrowup.svg";
import { useDashboard } from "hooks/hf/useDashboard";

export default function NgoDashboard() {
  const [isOpen, setIsOpen] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleApplyFilter = () => {
    console.log("Filtering from", fromDate, "to", toDate);
    setIsOpen(false);
  };

  const { user } = useUser();
  const { dashboard } = useDashboard();

  return (
    <div className="h-full w-full flex flex-col gap-3 overflow-y-scroll">
      <div className="flex justify-between flex-col gap-2">
        <h1 className="text-2xl font-semibold leading-[28px] tracking-[-0.48px]">
          Hello {user?.firstname}
        </h1>
        <div className="w-[100%]  flex items-start flex-col justify-between gap-3">
          <p className="text-base leading-[20.3px] text-[#475367]">
            It’s a beautiful day.check out the analytics and report for today
          </p>
          <div className=" w-full relative flex items-center justify-end">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="w-[190px] h-[40px] rounded-3xl border-[#000000] border text-black flex items-center justify-between px-[10px]  hover:bg-[#ededed] transition-all"
            >
              <img src={filterImg} alt="Filter Icon" />
              <span className="mx-2">Filter by Date</span>
              <img src={isOpen ? angle_up : angle_down} alt="Toggle Arrow" />
            </button>

            {isOpen && (
              <div className="absolute top-[45px] right-[10px] md:w-[340px] w-[300px] bg-white border border-gray-300 rounded-lg shadow-lg p-2">
                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-semibold mb-1">
                    From:
                  </label>
                  <div className="relative">
                    <input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      className="w-full px-4 py-1 border border-gray-300 rounded-md"
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <img src={calendar} alt="" />
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-semibold mb-1">
                    To:
                  </label>
                  <div className="relative">
                    <input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      className="w-full px-4 py-1 border border-gray-300 rounded-md"
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <img src={calendar} alt="" />
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleApplyFilter}
                  className="w-full bg-[#2C9BD7] hover:bg-[#4191bd] text-white font-medium py-1.5 px-4 rounded-md transition-colors"
                >
                  Apply Filter
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <NgoDashboardContainer dashboard={dashboard} />
    </div>
  );
}
